import React from 'react'

import Table from '../../components/BPMTable/TableComponents/TableWrapper/SetupTableData'
import RankingUsagesTableCreator from '../../tableDefinitions/Ranking/RankingUsagesTableCreator'
import tableCreatorCreatorFactoryCreator from '../../components/BPMTable/TableCreatorFactory/TableCreatorCreatorFactoryCreator'

function RankingUsagesTable(props) {
    var tableCreatorCreator = tableCreatorCreatorFactoryCreator.getTableCreatorCreatorFromIdentifier(RankingUsagesTableCreator.getId(), {tcFilters: props.filters})
    tableCreatorCreator.setParentProps(props)
    const tableCreator = tableCreatorCreator.getTableCreator('Ranking Ussages')

    return (
        <Table
            TableCreator={tableCreator}
            stickyHeader
        />
    )
}

export default (RankingUsagesTable)